import { Chat, GetStreamConfig } from '@/config'
import { GetChatClientOptions, getChatClient as getClient } from '@packages/chat'

export function getChatUser() {
  return Chat.Store.userState.get()
}

export const getChatClient = (options?: GetChatClientOptions) => {
  return getClient(GetStreamConfig.values.chatApiKey, options)
}

